"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _reactIntl = require("react-intl");

var messages = (0, _reactIntl.defineMessages)({
  namePlaceholder: {
    id: 'EmailPasswordSignUpForm.namePlaceholder',
    defaultMessage: 'Enter your name',
    description: 'Placeholder for the name input in the sign up form'
  },
  emailPlaceholder: {
    id: 'EmailPasswordSignUpForm.emailPlaceholder',
    defaultMessage: 'Enter your email',
    description: 'Placeholder for the email input in the sign up form'
  },
  passwordPlaceholder: {
    id: 'EmailPasswordSignUpForm.passwordPlaceholder',
    defaultMessage: 'Enter your password',
    description: 'Placeholder for the password input in the sign up form'
  }
});
var _default = messages;
exports["default"] = _default;